:host {
  display: inline-block;
  --gap: var(--sc-spacing-small);
}
.button-group {
  display: flex;
  flex-wrap: wrap;

  &--separate {
    gap: var(--gap);
  }


}
